export default function () {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7177_82219)">
                <path
                    d="M27.8 5H10V14H27.8C28.4627 14 29 13.4627 29 12.8V6.2C29 5.53726 28.4627 5 27.8 5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25 24.5L25 14L20 14L20 24.5C20 25.8807 21.1193 27 22.5 27C23.8807 27 25 25.8807 25 24.5Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12V7H5.71672C5.90301 7 6.08675 6.95663 6.25337 6.87331L10 5V14L6.25337 12.1267C6.08675 12.0434 5.90301 12 5.71672 12H4Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M20 19H22" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 22H22" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7177_82219">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
